import { captureException } from '@sentry/react'
import { createFileRoute, notFound, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { collections } from '@/schema'

const SearchParamsZod = z.object({
  central_id: import.meta.env.VITE_PILOTE_CENTRAL_ID
    ? z
        .number()
        .optional()
        .default(Number(import.meta.env.VITE_PILOTE_CENTRAL_ID))
    : z.number().optional(),
})

export const Route = createFileRoute('/dashboard/')({
  validateSearch: SearchParamsZod,
  beforeLoad: async ({ search, context }) => {
    if (search.central_id) {
      const region = await collections.regions.findUnique({
        name: `region for central id ${search.central_id}`,
        where: [['piloteId', '==', search.central_id]],
      })
      if (region) {
        throw redirect({
          to: '/dashboard/$regionId',
          params: {
            regionId: region._id,
          },
          replace: true,
        })
      }
    }
    if (context.auth.regionId) {
      throw redirect({
        to: '/dashboard/$regionId',
        params: {
          regionId: context.auth.regionId,
        },
        replace: true,
      })
    }
    throw notFound()
  },
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
